<template>
  <div class="p-8 h-screen flex flex-col bg-gray-800 text-gray-100">

    <div class="flex justify-between items-center mb-6">
      <h2 class="text-3xl font-bold">Lista de Mensagens</h2>
      <button
          @click="showCreateMessageModal = true"
          class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-md shadow-md transition duration-300 ease-in-out">
        Criar Mensagem
      </button>
    </div>

    <div v-if="loading" class="text-center p-8">
      Carregando mensagens...
    </div>

    <div v-if="!loading" class="overflow-x-auto bg-gray-900 rounded-lg shadow">
      <table class="min-w-full border border-gray-700">
        <thead class="bg-gray-700">
        <tr>
          <th class="px-4 py-2 text-left border-b border-gray-600">ID</th>
          <th class="px-4 py-2 text-left border-b border-gray-600">Mensagem</th>
          <th class="px-4 py-2 text-left border-b border-gray-600">Criado por</th>
          <th class="px-4 py-2 text-left border-b border-gray-600">Ações</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="msg in messagesList" :key="msg.id" class="hover:bg-gray-800">
          <td class="px-4 py-2 border-b border-gray-600">{{ msg.id }}</td>
          <td class="px-4 py-2 border-b border-gray-600">{{ msg.message || '(vazio)' }}</td>
          <td class="px-4 py-2 border-b border-gray-600">{{ msg.created_by || 'Desconhecido' }}</td>
          <td class="px-4 py-2 border-b border-gray-600">
            <button
                @click="sendMessage(msg.id)"
                class="bg-green-600 hover:bg-green-700 text-white font-bold py-1 px-3 rounded-md">
              Disparar
            </button>
          </td>
        </tr>
        <tr v-if="!messagesList.length">
          <td colspan="4" class="px-4 py-4 text-center text-gray-400">
            Nenhuma mensagem encontrada
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div
        v-if="showCreateMessageModal"
        class="fixed inset-0 bg-gray-900 bg-opacity-75 flex justify-center items-center z-50">
      <div class="relative p-6 bg-gray-800 text-gray-100 w-full max-w-md rounded-lg shadow-xl">
        <div class="flex justify-between items-center pb-3 border-b border-gray-700">
          <h3 class="text-xl font-bold">Criar Nova Mensagem</h3>
          <button @click="closeModal" class="text-gray-400 hover:text-gray-200 text-2xl font-semibold">&times;</button>
        </div>

        <div class="mt-4">
          <label class="block mb-2">Mensagem:</label>
          <textarea
              v-model="newMessage"
              class="w-full p-2 rounded bg-gray-700 border border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
              rows="4">
          </textarea>
        </div>

        <div class="mt-4 flex justify-end gap-2">
          <button
              @click="closeModal"
              class="bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded-md">
            Cancelar
          </button>
          <button
              @click="createMessage"
              class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-md">
            Salvar
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import messageRepository from '#repositories/messageRepository';

export default {
  name: "MessageList",
  data() {
    return {
      messagesList: [],
      showCreateMessageModal: false,
      newMessage: "",
      loading: false,
    };
  },
  methods: {
    async fetchMessages() {
      this.loading = true;
      try {
        const response = await messageRepository.fetchMessages();
        this.messagesList = response.data || [];
      } catch (error) {
        console.error('Erro ao buscar mensagens:', error);
        this.$notify('Erro ao buscar a lista de mensagens.', 'error');
      } finally {
        this.loading = false;
      }
    },

    async sendMessage(id) {
      try {
        await messageRepository.sendMessage(id);
        this.$notify('Mensagem disparada com sucesso!', 'success');
      } catch (error) {
        this.$notify('Erro ao disparar a mensagem.', 'error');
      }
    },

    async createMessage() {
      if (!this.newMessage.trim()) {
        this.$notify("Digite uma mensagem antes de salvar.", "warn");
        return;
      }

      this.loading = true;
      try {
        await messageRepository.createMessage({ message: this.newMessage });
        this.$notify("Mensagem criada com sucesso!", 'success');
      } catch (error) {
        this.$notify('Erro ao criar mensagem.', 'error');
      } finally {
        this.loading = false;
        this.newMessage = "";
        this.closeModal();
        await this.fetchMessages();
      }
    },

    closeModal() {
      this.showCreateMessageModal = false;
      this.newMessage = "";
    },
  },
  mounted() {
    this.fetchMessages();
  },
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
</style>